import React from 'react';
import { SecondaryButton, DefaultButton } from '@magoosh/lib/button';
import { paths } from 'config/path_helpers';

interface Props {
  handleClose: () => void;
}

export const UpgradeForAccessMessage: React.FC<Props> = (props) => {
  return (
    <>
      <p>
        Your free trial doesn’t include this. For instant access, choose the plan that’s right for you
        and subscribe. You’ll also get all of our questions, practice tests, section tests, and more.
      </p>
      <span>
        <SecondaryButton href={paths.plans()} target="_blank">
          Upgrade
        </SecondaryButton>
        <DefaultButton className="u-margin-L-s" onClick={props.handleClose}>
          Maybe Later
        </DefaultButton>
      </span>
    </>
  );
}

export default UpgradeForAccessMessage;
